var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoNewLot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "31px",
    viewBox: "0 0 36 31",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-954.000000, -1069.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(955.000000, 1070.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new-lot"
  }, /*#__PURE__*/React.createElement("g", {
    id: "paka",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeDasharray: 2,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.6,8.84140625 L8.41176758,0.9 L17.2364746,0.9 L17.2364746,0.9 L20.624707,0.9 L28.4364746,8.84140625",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(21.000000, 16.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 Z M5.9,6 L2.7,6 L2.7,8.1328125 L5.9,8.1328125 L5.9,11.3152344 L8.0328125,11.3152344 L8.0328125,8.1328125 L11.3152344,8.1328125 L11.3152344,6 L8.0328125,6 L8.0328125,2.7 L5.9,2.7 L5.9,6 Z",
    id: "Combined-Shape"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M27.9664063,15.6120605 L27.9664063,10.1672363 L0.6,10.1672363 L0.6,24 L20.5,24",
    id: "Path-86",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeDasharray: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoNewLot);
export default __webpack_public_path__ + "static/media/ico_new-lot.05e3bc5c684d5975f1c253c6d45ba558.svg";
export { ForwardRef as ReactComponent };